// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--zoIo6","list":"list--o7Piy","uploadButton":"uploadButton--aN80S"};